import { CancelledPlan } from '../../Dashboard.types';
import { formatDate } from '../../utils/date';

export const CancelledView = ({ plan }: { plan: CancelledPlan }) => {
  return (
    <div className="px-l py-m text-m font-reg text-structure-20">
      This order was cancelled on {formatDate(plan.cancelled_at)}. No payment
      schedule was started and no payment has been taken.
      <p className="mt-l">
        If you have questions about this order, please contact your supplier.
      </p>
    </div>
  );
};
